import ShopifyDetails from 'components/store/storeDetails/shopify/shopifyDetails';

const ShopifyDetailsPage = () => {
  return <ShopifyDetails />;
};

export default ShopifyDetailsPage;
